// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogPost_wrapper__3ssAH","progressContainer":"BlogPost_progressContainer__2KNDs","progressBar":"BlogPost_progressBar__1xfGl"};